import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { TimeHelper } from "common-import/helpers"
import { Link } from "react-router-dom";
import { makeInput } from "common-import/custom";
import { inject, observer } from "mobx-react";

@inject("projectStore", "contractorStore", "userStore") @observer
class ContractorList extends Component {

  state = {
    keyword: "",
    page: 1
  }

  async componentDidMount() {
    const { projectStore } = this.props;
    await this.props.userStore.onReady();
    let getListResult = await projectStore.getListNotApproved(this.state.page);
  }

  renderRow(data, index) {
    return (

      <tr key={"row" + index}>
        <td>
          <Link to={`/project/${data.id}?name=${data.name}`}>
            <div><strong>{data.name}</strong></div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">{data.type}</div>
          </div>
        </td>
        <td>
          <a >
            <div>{data.city}</div>
            <div className="small text-muted">
              <span>District</span>: {data.district}
            </div>
            <div className="small text-muted">
              <span>Address</span>: {data.address}
            </div>
            {/* <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div> */}
          </a>
        </td>
        <td>
          <div className="small text-muted">{data.status}</div>
        </td>
        <td>
          <div className="small text-muted"><strong>Start:</strong> {TimeHelper.toDateString(data.minStartTime)}</div>
          <div className="small text-muted"><strong>End:</strong> {TimeHelper.toDateString(data.maxFinishTime)}</div>
        </td>
      </tr>

    )
  }

  render() {
    const { projectStore } = this.props;
    const listNotApproved = projectStore.listNotApproved.slice();
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Nhập tên để tìm dự án chưa duyệt" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th>Project Name</th>
                  <th>Type</th>
                  <th>Address</th>
                  <th>Status</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
                {listNotApproved.length > 0 && listNotApproved.map((val, index) => this.renderRow({
                  id: val.id,
                  name: val.name,
                  type: val.projectType,
                  budget: val.maxBuget,
                  status: val.status,
                  address: val.address,
                  district: val.district,
                  city: val.city,
                  minStartTime: val.minStartTime,
                  maxFinishTime: val.maxFinishTime
                }, index))}
              </tbody>
            </Table>
            {listNotApproved.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Hiện chưa có dự án nào chưa được xác thực</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
              <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>

      </div>
    );
  }

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    const { projectStore } = this.props;
    this.setState({ page: this.state.page - 1}, () => {
      projectStore.getListNotApproved(this.state.page);
    });
  }

  loadNext = e => {
    !!e && e.preventDefault();
    const { projectStore } = this.props;
    this.setState({ page: this.state.page + 1}, () => {
      projectStore.getListNotApproved(this.state.page);
    });
  }

  search = e => {
    !!e && e.preventDefault();
    const { projectStore } = this.props;
    const { keyword } = this.state;
    if (keyword == "") {
      projectStore.getListNotApproved();
    } else {
      projectStore.search(keyword, false);
    }
  }
}

export default ContractorList;


// WEBPACK FOOTER //
// ./src/views/Projects/NotApprovedList.js